import { render, staticRenderFns } from "./index.vue?vue&type=template&id=459991d1&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=459991d1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459991d1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nortonpigozzo/Development/nisoftwares/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('459991d1')) {
      api.createRecord('459991d1', component.options)
    } else {
      api.reload('459991d1', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=459991d1&scoped=true", function () {
      api.rerender('459991d1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/pages/panorama/index.vue"
export default component.exports